import { render, staticRenderFns } from "./ProfesorComponent.vue?vue&type=template&id=2abded2f"
import script from "./ProfesorComponent.vue?vue&type=script&lang=js"
export * from "./ProfesorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports